// extracted by mini-css-extract-plugin
export default {"hr":"pH214Z__m3qTXUiGEYjB","light":"HedVODBdQSvoZk0baV6I","pulse":"S8BHQBz0U_Ve58Ell6ze"};